import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';
@Component({
  selector: 'app-update-campaign-review-action-item',
  templateUrl: './update-campaign-review-action-item.component.html',
  styleUrls: ['./update-campaign-review-action-item.component.scss']
})
export class UpdateCampaignReviewActionItemComponent implements OnInit {
  // private _serverService: any;
  // adminUser: any;
  authToken = localStorage.getItem('token')

  btnStatus = true;
  done_remark:any = ''
  actionItems:any
  constructor(
    private dialogRef: MatDialogRef<UpdateCampaignReviewActionItemComponent>,
    private _serverService:ServerService,
    private clipBoardService:ClipBoardService,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    // console.log(this.data)
    this.actionItems = this.data
  }
  close() {
    this.dialogRef.close();
}

apply(){
  this.btnStatus = true;
  let url = 'campaign_module/campaign_reviews/update_action_item/'+ this.actionItems.id
  let body = {
    "campaign_id": this.data.campaign_id,
    "campaign_review_id": this.actionItems.campaign_review_id,
    "done_remarks": this.done_remark,
    "is_mark_done": true
  }
  // let url = this.data.id;
  this._serverService.updateCampaignReviewActionItems(url,body,this.authToken).subscribe((data)=>{
      this.dialogRef.close(data);
      this.clipBoardService.showMessgeInText("Action Item Marked as done Successfully", "success-snackbar")
   
  },
  error => {
   console.error('User Assigned failed', error);
   this.btnStatus = false;
   // this.showComponentLoader = false;
 })

}
}
